import React from "react";
import { useGlobalContext } from "../context";
import Loading from "./Loading";
import Cocktail from "./Cocktail";
const CocktailList = () => {
  const { loading, cocktails } = useGlobalContext();
  if (loading) {
    return <Loading />;
  }
  if (cocktails.length < 1) {
    return (
      <h2 className="section-title">
        no cocktails matched your search criteria
      </h2>
    );
  } else {
    return (
      <div className="section">
        <h2 className="section-title">
          Cocktails
          <div className="cocktails-center">
            {cocktails.map((cocktail) => {
              const { id } = cocktail;
              return <Cocktail key={id} {...cocktail} />;
            })}
          </div>
        </h2>
      </div>
    );
  }
};

export default CocktailList;
